import { defineMessages } from 'react-intl';

export default defineMessages({
  serviceAlertText: {
    defaultMessage: 'The payment gateway is currently not available' + ' due to problems on the provider',
    description: 'Service alert - text',
    id: 'serviceAlert.text',
  },
});
